import { Box, Tooltip, Typography } from "@mui/material";
import { exportIncomeTaxReturns, getIncomeTaxReturns } from "api/services/automation/income-tax";
import SearchContainer from "components/SearchContainer";
import Table, { ColumnType } from "components/Table";
import { useEffect, useMemo, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { ResType } from "types";
import { calculateAssessmentYear, dropDownType } from "./constants";
import moment from "moment";
import useTitle from "hooks/useTitle";
import { getAutFinancialYears } from "utils/getFinancialYears";
import { snack } from "components/toast";
import { getOrganizationPreference } from "api/services/common";
import { getCurrentFormattedDateTime } from "utils";
import { handleError } from "utils/handleError";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";
import { SortDirection } from "data/constants";
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import { Chip, Stack } from "@mui/material";
import FilterEngine from "./Filters";
import { buildChips } from "./Filters/buildChips";
import excelIcon from "./../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";
import clearFilters from "./../../assets/images/clear-filter.svg";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { formatToRupeess } from "utils/formattedAmount";
import React from "react";
import { hasActiveFilters } from "./Filters/components";
import useClientCategories from "hooks/useClientCategories";

const itrTypes = {
  "1": "ITR-1",
  "2": "ITR-2",
  "2A": "ITR-2A",
  "3": "ITR-3",
  "4": "ITR-4",
  "4S": "ITR-4S",
  "5": "ITR-5",
  "6": "ITR-6",
  "7": "ITR-7",
};

const filingTypes = {
  O: "Original",
  D: "Defective",
  R: "Revised",
  T: "Rectification",
  U: "Updated",
};

const verificationStatus = {
  Y: "Verified",
  N: "Not Verified", //red
  X: "NA",
  empty: "None",
};

const IncomeTaxReturns = () => {
  useTitle("ATOM Pro | Returns");
  const navigate = useNavigate();
  const { permissions } = usePermissions();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [filters, setFilters] = useState<any>({
    itrType: null,
    filingType: [] as String[],
    assessmentYear: null,
    status: null,
    clientCategory: null,
  });
  const {
    categories,
  } = useClientCategories({});

  const location = useLocation();
  const state: any = location.state;

  const { data: incomeTaxAccess, isLoading: isLoadingIncomeTaxAccess }: ResType = useQuery(
    ["Income Tax Access Check"],
    getOrganizationPreference,
    {
      onSuccess: (res: any) => {
        if (res?.data?.automationConfig?.incomeTax === "YES") {
        } else {
          snack.error("Please subscribe Atom Pro Income tax");
          navigate("/atom-pro/incomeTaxLimit");
        }
      },
      enabled:
        permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
        permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
    }
  );
  const [sort, setSort] = useState<any>({});

  const { data, isLoading }: ResType = useQuery(
    [
      "income-tax-returns",
      {
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        ...filters,
        sort,
      },
    ],
    getIncomeTaxReturns,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
      enabled:
        permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
        permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
    }
  );

  useEffect(() => {
    if (state?.filingType) {
      setFilters(prev => ({
        ...prev,
        filingType: [...state?.filingType],
        assessmentYear: state?.assessmentYear,
      }));
      setPage(0);
    } else if (state?.status) {
      setFilters(prev => ({ ...prev, status: state?.status, assessmentYear: state?.assessmentYear }));
      setPage(0);
    } else if (state?.itrType) {
      setFilters(prev => ({ ...prev, itrType: state?.itrType, assessmentYear: state?.assessmentYear }));
      setPage(0);
    }
  }, [state]);

  const getFilingType = (type) => {
    const abc = filingTypes[type];
    return abc;
  };

  const getformType = (type) => {
    const abc = itrTypes[type];
    return abc;
  };


  let defaultColumns: Array<ColumnType> = [
    {
      key: "assmentYear",
      title: "Assessment Year",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => (
        <Typography variant="body2">AY {calculateAssessmentYear(row.assmentYear)}</Typography>
      ),
    },
    // {
    //   key: "category",
    //   sort: true,
    //   active: false,
    //   direction: SortDirection.ASC,
    //   default: true,
    //   title: (
    //     <Box display="flex" alignItems="center">
    //       {/* <CategoryIcon style={{ width: "20px", marginRight: "5px" }} /> */}
    //       Category
    //     </Box>
    //   ),
    //   render: (v) => {
    //     const categoryLabel =
    //       clientCategories.find((category) => category.value === v?.client?.category)?.label || "";
    //     return (
    //       <Typography
    //         sx={{
    //           maxWidth: 90,
    //           whiteSpace: "nowrap",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //         }}
    //         title={categoryLabel}
    //       >
    //         {categoryLabel}
    //       </Typography>
    //     );
    //   },
    // },
    {
      key: "clientId",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      title: (
        <Box display="flex" alignItems="center">
          {/* <PersonOutlineOutlinedIcon style={{ width: "20px", marginRight: "5px" }} />  */}
          Name (PAN)
        </Box>
      ),
      render: (row) => (
        <Typography
          sx={{
            maxWidth: 150,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={`${row?.client?.displayName} (${row?.autClientCredentials?.panNumber})`}
        >
          {row?.client?.displayName} (<span>{row?.autClientCredentials?.panNumber}</span>)
        </Typography>
      ),
    },

    {
      key: "filingTypeCd",
      title: "Filing Type",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return <Typography>{getFilingType(row?.filingTypeCd)}</Typography>;
      },
    },
    {
      key: "formtypeCd",
      title: "ITR",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return <Typography>{getformType(row?.formtypeCd)}</Typography>;
      },
    },

    {
      key: "id",
      title: "Filing Date",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{moment(row.submitTmstmp).format("DD MMM YYYY")}</Typography>
        );
      },
    },
    {
      key: "ackNum",
      title: "Acknowledgement #",
    },


    {
      key: "verStatus",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      title: (
        <Typography display="flex" alignItems="center">
          Verification Status
        </Typography>
      ),
      render: (row: any) => (
        <Typography
          sx={{
            backgroundColor:
              row?.verStatus === "Y" ? "#79c97a" : row?.verStatus === "N" ? "#ff3535" : "",
            display: "inline-block",
            padding: "1px 5px",
            border: row?.verStatus
              ? `1px solid ${row?.verStatus === "Y" ? "#79c97a" : row?.verStatus === "N" ? "#ff3535" : ""
              }`
              : "",
            borderRadius: "4px",
            color: "#222222",
            fontSize: "12px",
          }}
        >
          {row?.verStatus ? verificationStatus[row?.verStatus] : "--"}
        </Typography>
      ),
    },
    {
      key: "refundAmt",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      title: (
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <Box>Refund Claimed</Box>
        </Box>
      ),
      render: (v) => {
        const hasAdditionalInfo =
          v?.interAmt ||
          v?.computedRefndAmt ||
          v?.clearanceDt ||
          v?.accountNo ||
          v?.paymentMode ||
          v?.brn;
        return (
          <Box display="flex" justifyContent="flex-end" width="100%">
            <Tooltip
              title={
                <>
                  Refund Claimed: {v?.refundAmt ? formatToRupeess(v?.refundAmt) : 0}
                  <br />
                  Interest Amount: {v?.interAmt ? formatToRupeess(v?.interAmt) : 0}
                  <br />
                  Computed Refund Amount: {v?.computedRefndAmt ? formatToRupeess(v?.computedRefndAmt) : 0}
                  <br />
                  Clearance Date: {v?.clearanceDt || "-"}
                  <br />
                  Account #: {v?.accountNo || "-"}
                  <br />
                  Mode: {v?.paymentMode || "-"}
                  <br />
                  BRN: {v?.brn || "-"}
                </>
              }
            >
              <Box display="flex" alignItems="center">
                <CurrencyRupeeIcon sx={{ width: "15px", mr: 0.5 }} />
                <Typography color={hasAdditionalInfo && '#008100'} sx={{ fontWeight: hasAdditionalInfo && 'bold' }}>
                  {formatToRupeess(v?.refundAmt)}
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        )
      },
    },

    {
      key: "timeLineDate",
      title: "Status Updated At",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => (
        <Typography>
          {row?.timeLineDate
            ? moment(parseInt(row?.timeLineDate)).format("DD MMM YYYY hh:mm")
            : "--"}
        </Typography>
      ),
    },
    {
      key: "timeLineDesc",
      title: "Status Description",
      sort: true,
      active: false,
      direction: SortDirection.ASC,
      default: true,
      render: (row: any) => (
        <Typography
          sx={{
            maxWidth: 150,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={row?.timeLineDesc ? row?.timeLineDesc : "--"}
        >
          {row?.timeLineDesc ? row?.timeLineDesc : "--"}
        </Typography>
      ),
    },
  ];
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };
  const handleRowClick = (v: any) => {
    navigate(`/atom-pro/income-tax/return/${v?.id}`);
  };

  const handleSearch = (e: any) => {
    setSearch(e);
    setPage(0);
  };

  // const assessmentYear = getAutFinancialYears();
  const assessmentYear = useMemo(
    () => getAutFinancialYears(),
    []
  );

  const clientCategoryOptions =
    useMemo(() => {

      return categories.reduce(
        (acc: any, item: any) => {

          acc[String(item.id)] =
            item.name;

          return acc;

        },
        {},
      );

    }, [categories]);
  const { mutate: mutate1, isLoading: isExporting } = useMutation(exportIncomeTaxReturns, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      const formattedDateTime = getCurrentFormattedDateTime();

      let link = document.createElement("a");
      link.href = file;
      link.download = `ATOM Pro - Income Tax Returns ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax (PAN) Returns exported successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });
  const handleExport = () => {
    if (isExporting) return;
    mutate1({
      ...state,
      limit: pageCount,
      offset: page * pageCount,
      ...filters,
    });
  };

  const filterConfig = React.useMemo(() => {
    return {
      assessmentYear: {
        label: "Assessment Year",
        type: "year",
        options: assessmentYear,
        getValue: (year) => year.split("-")[0],
      },
      itrType: {
        label: "ITR",
        type: dropDownType.object,
        options: itrTypes,
      },
      filingType: {
        label: "Filing",
        type: dropDownType.object,
        options: filingTypes,
        multiple: true
      },
      status: {
        label: "Status",
        type: dropDownType.object,
        options: verificationStatus,
      },
      clientCategory: {
        label: "Category",
        type: dropDownType.object,
        options: clientCategoryOptions,
      },
    };

  }, [
    assessmentYear,
    clientCategoryOptions,
  ]);


  const chips: any = buildChips(filters, filterConfig);

  const isFilterActive = hasActiveFilters(filters);


  if (
    !(
      permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
      permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
    )
  ) {
    return <AccessDenied />;
  }
  return (
    <>
      <Box m={1}>
        <Box pr={2} pl={2} sx={{ display: "flex", justifyContent: 'space-between' }}>
          <Box>
            <SearchContainer
              minWidth="330px"
              value={search}
              debounced
              placeHolder="Search by Client Name | PAN"
              onChange={handleSearch}
            />
          </Box>

          <Box display='flex'>
            <Box>
              <FilterEngine
                config={filterConfig}
                filters={filters}
                setFilters={setFilters}
                setPage={setPage}
              />
            </Box>
            {isFilterActive && (
              <Tooltip title={'Reset Filters'}>
                <img
                  src={clearFilters}
                  alt="Export"
                  style={{ cursor: 'pointer', width: 38, height: 38, marginRight: "20px", marginLeft: "20px" }}
                  onClick={() => {
                    setFilters({
                      itrType: null,
                      filingType: [] as String[],
                      assessmentYear: null,
                      status: null,
                      clientCategory: "",
                    });
                    setSearch("");
                  }}
                />
              </Tooltip>
            )}

            <Tooltip title={isExporting ? "Exporting..." : "Data Export to Excel"}>
              <img
                src={excelIcon}
                alt="Export"
                style={{ cursor: isExporting ? "not-allowed" : "pointer", width: 33, height: 33, marginTop: "2px", opacity: isExporting ? 0.5 : 1, pointerEvents: isExporting ? "none" : "auto" }}
                onClick={handleExport}
                aria-disabled={isExporting}
              />
            </Tooltip>
          </Box>
        </Box>
        <Box>


          <Stack direction="row" spacing={1} sx={{ mb: 1, ml: 2, mt: 1, flexWrap: "wrap" }}>
            {chips.map((chip) => (
              <Chip
                key={chip.key}
                label={chip.label}
                // onDelete={() => {
                //   const updated = { ...filters, [chip.key]: "" };
                //   setFilters(updated);
                // }}
                onDelete={() => {
                  setFilters(prev => ({
                    ...prev,
                    [chip.key]:
                      Array.isArray(prev[chip.key]) ? [] : null
                  }));
                }}
                variant="outlined"
                color="primary"
              />
            ))}
          </Stack>
        </Box>

        <Box mt={1}>
          <Table
            sx={{ pb: 0, mb: 0, height: "530px" }}
            pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
            data={data?.data.result || []}
            columns={columns}
            sortHandler={handleSort}
            loading={isLoading}
            onRowClick={handleRowClick}
          />
        </Box>
      </Box>
    </>
  );
};



export default IncomeTaxReturns;
